import React, { useRef } from 'react';
import bem from 'utils/bem';
import MobileMenu from 'components/Menu/MobileMenu';
import LoginButton from 'components/LoginButton';
import Logo from 'components/Logo';
import useSticky from '../useSticky';
import CartWidget from 'components/CartWidget';

import './index.sass';

const { block, el } = bem('mobile-fixed-header');

const MobileFixedHeader = ({ menu, open, setOpen }) => {
    const ref = useRef(null);
    const menuRef = useRef(null);
    const { sticky, animated } = useSticky(ref);

    return (
        <div className={ block() } ref={ ref }>
            <div className={ el('menu-anchor') } ref={ menuRef }/>
            <div className={ el('box', { 'animated': animated || open, 'sticky': sticky, 'open': open }) }>
                <div className={ el('content', { 'fixed': true }) }>
                    <div className={ el('menu') }>
                        <MobileMenu
                            isOpen={ open }
                            setIsOpen={ setOpen }
                            anchor={ menuRef.current }
                            data={ menu }
                            mods={ { animated, sticky, 'black': true } }/>
                    </div>
                    <div className={ el('logo', { animated, sticky }) }>
                        <Logo/>
                    </div>
                    <div className={ el('cart') }>
                        <CartWidget/>
                    </div>
                    <div className={ el('login') }>
                        <LoginButton/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileFixedHeader;
